import * as t from "io-ts";
export function makeMessage(type, data) {
    return data
        ? t.intersection([
            t.type({
                type: t.literal(type)
            }),
            data
        ])
        : t.type({
            type: t.literal(type)
        });
}
export const version = t.union([
    t.literal("pre-protocol"),
    t.literal("v1"),
    t.literal("v2"),
    t.literal("v3")
]);
